import { render, staticRenderFns } from "./PosterWithQRCode.vue?vue&type=template&id=09b7106b&scoped=true&"
import script from "./PosterWithQRCode.vue?vue&type=script&lang=js&"
export * from "./PosterWithQRCode.vue?vue&type=script&lang=js&"
import style0 from "./PosterWithQRCode.vue?vue&type=style&index=0&id=09b7106b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b7106b",
  null
  
)

export default component.exports